export default __webpack_public_path__ + "static/media/person3@2x.c8c59e95.webp";